"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CURRENT_FPE_FORM_VERSION () {
        return CURRENT_FPE_FORM_VERSION;
    },
    get FPE_FORMS () {
        return FPE_FORMS;
    },
    get FPE_FORM_VERSION_MAX_LENGTH () {
        return _fpeformdescriptor.FPE_FORM_VERSION_MAX_LENGTH;
    },
    get FPE_FORM_VERSION_PATTERN () {
        return _fpeformdescriptor.FPE_FORM_VERSION_PATTERN;
    },
    get FpeFormVersionSchema () {
        return FpeFormVersionSchema;
    },
    get createFpeFormRegistry () {
        return createFpeFormRegistry;
    },
    get fpeFormRegistry () {
        return fpeFormRegistry;
    },
    get getFpeForm () {
        return getFpeForm;
    }
});
const _zod = require("zod");
const _buildfpeschemas = require("./build-fpe-schemas");
const _yakapfpev0 = require("./forms/yakap-fpe-v0");
const _fpeformdescriptor = require("./fpe-form-descriptor");
const FPE_FORMS = Object.freeze({
    [_yakapfpev0.YAKAP_FPE_V0.formVersion]: _yakapfpev0.YAKAP_FPE_V0
});
const CURRENT_FPE_FORM_VERSION = 'yakap-fpe-v0';
const FpeFormVersionSchema = _zod.z.string({
    message: 'formVersion must be text.'
}).max(_fpeformdescriptor.FPE_FORM_VERSION_MAX_LENGTH, {
    message: 'formVersion is too long.'
}).regex(_fpeformdescriptor.FPE_FORM_VERSION_PATTERN, {
    message: 'formVersion has the wrong format.'
});
const createFpeFormRegistry = (forms, current)=>{
    const byVersion = new Map();
    for (const [version, form] of Object.entries(forms)){
        if (form.formVersion !== version) {
            throw new Error(`FPE form registered as ${version} declares ${form.formVersion}`);
        }
        const problems = (0, _fpeformdescriptor.validateFpeFormDescriptor)(form);
        if (problems.length > 0) {
            throw new Error(`Invalid FPE form descriptor ${version}: ${problems.join('; ')}`);
        }
        byVersion.set(version, form);
    }
    if (!byVersion.has(current)) {
        throw new Error(`Current FPE form version ${current} is not registered`);
    }
    const schemaCache = new Map();
    const get = (version)=>byVersion.get(version) ?? null;
    return {
        current,
        versions: [
            ...byVersion.keys()
        ],
        get,
        getSchemas: (version)=>{
            const form = get(version);
            if (form === null) {
                return null;
            }
            let schemas = schemaCache.get(version);
            if (schemas === undefined) {
                schemas = (0, _buildfpeschemas.buildFpeSchemas)(form);
                schemaCache.set(version, schemas);
            }
            return schemas;
        }
    };
};
const fpeFormRegistry = createFpeFormRegistry(FPE_FORMS, CURRENT_FPE_FORM_VERSION);
const getFpeForm = (version)=>fpeFormRegistry.get(version);
